import React, { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

// Lazy loading des composants non critiques
const Footer = React.lazy(() => import('./Footer').then(module => ({ default: module.Footer })));
const StatsSection = React.lazy(() => import('./StatsSection').then(module => ({ default: module.StatsSection })));
const GamesList = React.lazy(() => import('./GamesList').then(module => ({ default: module.GamesList })));
const MonthlyResetCountdown = React.lazy(() => import('./MonthlyResetCountdown').then(module => ({ default: module.MonthlyResetCountdown })));

// Composant de fallback optimisé
const ComponentFallback = ({ height = "auto", className = "" }: { height?: string; className?: string }) => (
  <div className={`flex items-center justify-center ${className}`} style={{ minHeight: height }}>
    <Loader2 className="w-4 h-4 animate-spin text-gaming-primary opacity-50" />
  </div>
);

// Wrappers avec Suspense et fallbacks optimisés
export const LazyFooter = () => (
  <Suspense fallback={<ComponentFallback height="200px" className="bg-slate-900/50" />}>
    <Footer />
  </Suspense>
);

export const LazyStatsSection = () => (
  <Suspense fallback={<ComponentFallback height="120px" className="container mx-auto px-4" />}>
    <StatsSection />
  </Suspense>
);

export const LazyGamesList = () => (
  <Suspense fallback={
    <div className="modern-card p-6">
      <div className="h-6 bg-slate-700 rounded mb-4 w-32"></div>
      <div className="space-y-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-10 bg-slate-700/50 rounded animate-pulse"></div>
        ))}
      </div>
    </div>
  }>
    <GamesList />
  </Suspense>
);

export const LazyMonthlyResetCountdown = ({ variant = "compact" }: { variant?: "compact" | "full" | "mini" }) => (
  <Suspense fallback={
    <div className="bg-gradient-to-r from-gaming-primary/10 to-gaming-secondary/10 border border-gaming-primary/20 rounded-lg p-4">
      <div className="h-4 bg-slate-700/50 rounded w-48 mx-auto animate-pulse"></div>
    </div>
  }>
    <MonthlyResetCountdown variant={variant} />
  </Suspense>
);